import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 py-12 px-6" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
          {/* Column 1 */}
          <div>
            <div className="font-semibold text-gray-900 mb-3">AcuSightPro</div>
            <p className="text-gray-600 leading-relaxed">
              An end-to-end acquisition and diligence operating system that helps agencies do more deals with the teams they
              already have.
            </p>
          </div>

          {/* Column 2 */}
          <div>
            <nav className="flex flex-col gap-2">
              <Link to="/product" className="text-gray-600 hover:text-gray-900 transition-colors">
                Product
              </Link>
              <Link to="/workflow" className="text-gray-600 hover:text-gray-900 transition-colors">
                Workflow
              </Link>
              <Link to="/tech-security" className="text-gray-600 hover:text-gray-900 transition-colors">
                Tech &amp; Security
              </Link>
              <Link to="/acquisition-portal" className="text-gray-600 hover:text-gray-900 transition-colors">
                Acquisition Portal
              </Link>
              <Link to="/support" className="text-gray-600 hover:text-gray-900 transition-colors">
                Support
              </Link>
              <Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors">
                Contact
              </Link>
            </nav>
          </div>

          {/* Column 3 */}
          <div className="flex flex-col gap-2">
            <span className="text-gray-600">&copy; {currentYear} Encore Services, LLC · SDVOSB · Powered by ACI · U.S. Patent Pending #63/987,765</span>
            <Link to="/privacy" className="text-gray-600 hover:text-gray-900 transition-colors text-xs">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-600 hover:text-gray-900 transition-colors text-xs">
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
